import React from "react";
// import { graphql, StaticQuery } from "gatsby";
import { Trans } from 'gatsby-plugin-react-i18next';

import Scrollbar from 'smooth-scrollbar';
import OverscrollPlugin from 'smooth-scrollbar/plugins/overscroll';

import './looks.scss';
import look1 from "../../images/looks/look-1-alt.png";
import look1Mobile from "../../images/looks/look-1-alt-mobile.png";
import look2 from "../../images/looks/look-2-alt.png";
import look2Mobile from "../../images/looks/look-2-alt.png";
import look3 from "../../images/looks/look-3-alt.png";
import look3Mobile from "../../images/looks/look-3-alt-mobile.png";
import look4 from "../../images/looks/look-4-alt.png";
import look4Mobile from "../../images/looks/look-4-alt.png";
import look5 from "../../images/looks/look-5.png";
import look5Mobile from "../../images/looks/look-5.png";
import look6 from "../../images/looks/look-6.png";
import look6Mobile from "../../images/looks/look-6.png";
import logo from "../../images/Logo_Black_Simpler.svg";
import icon from "../../images/union.png";
import FAM16078000 from "../../images/grid/products/FAM16078000.jpg";
import FAM1170J72H from "../../images/grid/products/FAM1170J72H.jpg";
import FAM1344W000 from "../../images/grid/products/FAM1344W000.jpg";
import FAM0985M006 from "../../images/grid/products/FAM0985M006.jpg";
import FAM0189B0X1 from "../../images/grid/products/FAM0189B0X1.jpg";
import FAM1039B0X1 from "../../images/grid/products/FAM1039B0X1.jpg";
import FAM16061005 from "../../images/grid/products/FAM16061005.jpg";
import FAM1063WD57 from "../../images/grid/products/FAM1063WD57.jpg";
import FAM20738000 from "../../images/grid/products/FAM20738000.jpg";
import FAM20731000 from "../../images/grid/products/FAM20731000.jpg";


let InvertDeltaPlugin = (function(){
  
  class InvertDeltaPlugin extends Scrollbar.ScrollbarPlugin{
      /**
       * @inheritdoc
       */
      transformDelta(delta, fromEvent){
          const {x, y} = delta;
          if(this.shouldInvertDelta(fromEvent)){
            return {
                y: 0,
                x: Math.abs(x) > Math.abs(y) ? x : y
            }; 
          }
          
          return delta;
      }

      /**
       * @inheritdoc
       */
      onRender(remainMomentum){
        let elem = document.getElementsByClassName('j-looks')[0];
        // parallax function of the hotspost solo se no mobile
        let getViewport = () => {
          // return WindowHelper.window.innerWidth;
          if(typeof window !== 'undefined'){
            return window.safari ? document.body.parentNode.clientWidth : window.innerWidth;
          }
        }
        let isMobile = getViewport() <= 768;
        if(!isMobile){
          let hotSpots = document.querySelectorAll('.j-hotSpot');
          if(remainMomentum.x !== 0){
            const maxMomentum = Math.abs(remainMomentum.x);
            for(let i = 0; i<hotSpots.length; i++) {
              if(hotSpots[i].classList.contains('look__hotspot--stop')) {
                hotSpots[i].classList.remove('look__hotspot--stop')
              }
              hotSpots[i].style.transform = 'translateX(' + maxMomentum / ((i + 1) * 2)+ 'px)'
            }
          } else {
            if(elem){
              if(!hotSpots[0].classList.contains('look__hotspot--stop')) {
                for(let i = 0; i<hotSpots.length; i++) {
                  hotSpots[i].classList.add('look__hotspot--stop');
                  hotSpots[i].style.transform = 'translateX(' + 0 + 'px)'
                }
              }
            }  
          }
        }
      }
      
      /**
       * @inheritdoc
       */
      shouldInvertDelta(fromEvent){
          return this.options.events.some((rule) => {
              return fromEvent.type.match(rule);
          });
      };
      
  };
  
  InvertDeltaPlugin.pluginName = 'invertDelta';
  InvertDeltaPlugin.defaultOptions = {
      events: []
  };
  return InvertDeltaPlugin;
}
).call(this);
class Looks extends React.Component {
  constructor(props){
    super(props);
    this.products = props.products;
    this.state = {
      openedHotspot: null,
      hideMessage: false,
      lookOpen: false,
      hasScrolledCenter: false,
      hasClicked: false
    };
  }

  componentDidMount(){

    const looksItem = this.refs.looksItem;
    let isMobile = this.getViewport() <= 768;
    const dampingScroll = isMobile ? 0.1 : 0.05;
    Scrollbar.use(InvertDeltaPlugin);
    Scrollbar.use(OverscrollPlugin);
    Scrollbar.init(looksItem, {
      damping: dampingScroll,
      plugins: {
          invertDelta: {
              events: [/wheel/]
          },
          overscroll: {
              damping: 0.2,
              maxOverscroll: 0
          }   
      }
    });  
    // list of options
    const valueThreshold = isMobile ? 0.2 : 0.8;
    let options = {
      threshold: [valueThreshold]
    };

    let scrollbar = Scrollbar.get(looksItem, {});
    let timer = null;
    scrollbar.addListener(({ offset }) => {
      if(offset.x > 50 ){
        this.setState({ hasClicked: false});
        if(window.innerWidth <= 1024){
          if(timer !== null) {
            clearTimeout(timer);
            if(!document.body.classList.contains('navigator--hidden')) {
              document.body.classList.add('navigator--hidden');   
            }   
          }
          timer = setTimeout(() => {
            if(!this.state.lookOpen) {
              document.body.classList.remove('navigator--hidden')
            }
          }, 150);

        } else {
          if(document.body.classList.contains('navigator--hidden')) {
            document.body.classList.remove('navigator--hidden');   
          } 
        }
        // close modal look when scroll, but not when scroll after open hotspot
        if(!this.state.hasScrolledCenter) {
          if(this.state.lookOpen) {
            this.closeHotspot();
          }
        }
        this.setState({ hideMessage: true});
        
      }
      
     
    });
    let elements = document.getElementsByClassName('j-look');
    if(window['IntersectionObserver']){
        const observer = new IntersectionObserver(this.onEntry, options);
        for (let elm of elements){
            observer.observe(elm);
        }
    }
    this.setAlignHotspot()
  }

  setAlignHotspot() {
    const buttonHotspot = document.querySelectorAll('.j-buttonHotspot');
    for (let buttonElm of buttonHotspot){
      const rect = buttonElm.getBoundingClientRect();
      let product = buttonElm.parentNode.getElementsByClassName('hotspot__product')[0];
      if(rect.y < 200 ){
        product.classList.add('alignTop')
      }
      if(rect.y - 50 > window.innerHeight/2 ){
        product.classList.add('alignCenterBottom')
      }
      if(rect.y + 150 > window.innerHeight ){
        product.classList.remove('alignCenterBottom')
        product.classList.add('alignBottom')
      }
    }
  }

  onEntry(entries){
    entries.forEach((entry) => {
        if(entry.isIntersecting){
            entry.target.classList.add('visible');
        }
    });

  }

  closeHotspot() {
    let lookElement = document.querySelectorAll('.j-look');
    for (let lookElm of lookElement){
      lookElm.classList.remove('look--open');
    }
    this.setState({ openedHotspot: null});
    this.setState({ lookOpen: false});
  }

  render(){
    let helperObject = {};
    this.products.map((product,i) => {
      let sku = product.sku;
      helperObject[sku] = this.products[i]
    });

    let looks = [
      {
        imgDesktop:look1,
        imgMobile:look1Mobile,
        hotspots:[
          {
            top: "34%",
            left: "15%",
            topMobile:  "33%",
            leftMobile:  "13%",
            productSku:  "FAM16078000",
            productImg:  FAM16078000,
            productName:  "nome",
            productLink:  "url"
          },
          {
            top:  "46%",
            left:  "73%",
            topMobile:  "50%",
            leftMobile:  "71%",
            productSku:  "FAM1170J72H",
            productImg:  FAM1170J72H,
            productName:  "nome2",
            productLink:  "url2"
          }
        ]
      },
      {
        imgDesktop:look2,
        imgMobile:look2Mobile,
        hotspots:[]
      },
      {
        imgDesktop:look3,
        imgMobile:look3Mobile,
        hotspots:[
          {
            top:  "88%",
            left:  "3%",
            topMobile:  "89%",
            leftMobile:  "5%",
            productSku:  "FAM1344W000",
            productImg:  FAM1344W000,
            productName:  "nome",
            productLink:  "url"
          },
          {
            top:  "43%",
            left:  "26%",
            topMobile:  "43%",
            leftMobile:  "37%",
            productSku:  "FAM0985M006",
            productImg:  FAM0985M006,
            productName:  "nome2",
            productLink:  "url2"
          }
        ]
      },
      {
        imgDesktop:look4,
        imgMobile:look4Mobile,
        hotspots:[
          {
            top:  "32%",
            left:  "14%",
            topMobile:  "35%",
            leftMobile:  "16%",
            productSku:  "FAM0189B0X1",
            productImg:  FAM0189B0X1,
            productName:  "nome",
            productLink:  "url"
          },
          {
            top:  "67%",
            left:  "18%",
            topMobile:  "65%",
            leftMobile:  "24%",
            productSku:  "FAM1039B0X1",
            productImg:  FAM1039B0X1,
            productName:  "nome2",
            productLink:  "url2"
          },
          {
            top:  "9%",
            left:  "56%",
            topMobile:  "11%",
            leftMobile:  "57%",
            productSku:  "FAM20738000",
            productImg:  FAM20738000,
            productName:  "nome2",
            productLink:  "url2"
          }
        ]
      },
      {
        imgDesktop:look5,
        imgMobile:look5Mobile,
        hotspots:[
          {
            top:  "62%",
            left:  "62%",
            topMobile:  "57%",
            leftMobile:  "64%",
            productSku:  "FAM16061005",
            productImg:  FAM16061005,
            productName:  "nome",
            productLink:  "url"
          }
        ]
      },
      {
        imgDesktop:look6,
        imgMobile:look6Mobile,
        hotspots:[
          {
            top:  "63%",
            left:  "37%",
            topMobile:  "45%",
            leftMobile:  "37%",
            productSku:  "FAM1063WD57",
            productImg:  FAM1063WD57,
            productName:  "nome",
            productLink:  "url"
          },
          {
            top:  "5%",
            left:  "66%",
            topMobile:  "4%",
            leftMobile:  "63%",
            productSku:  "FAM20731000",
            productImg:  FAM20731000,
            productName:  "nome2",
            productLink:  "url2"
          }
        ]
      }
    ];

    this.getViewport = () => {
      // return WindowHelper.window.innerWidth;
      if(typeof window !== 'undefined'){
        return window.safari ? document.body.parentNode.clientWidth : window.innerWidth;
      }
    }


    let isMobile = this.getViewport() <= 768;
    let isMobileNotTablet = this.getViewport() < 768;
    let isMobileDescktop = this.getViewport() > 1024;

    this.openHotspot = (e, index, sku) => {
      this.setState({ openedHotspot: index});
      if(index){
        // controllare che i dati prodotti ci stiano
        const btn = e.currentTarget;
        let product = btn.parentNode.getElementsByClassName('hotspot__product')[0];
        let parentElem = e.currentTarget.closest('.j-look');
        parentElem.classList.add('look--open');
        this.setState({ lookOpen: true});
        e.stopPropagation()
        // su mobile, per averlo sempre centrato si sposta la scrollbar di tanto quanto serve per avere la card centrata
        if(isMobileNotTablet){
          this.setState({ hasScrolledCenter: true})
          const looksItem = this.refs.looksItem;
          let scrollbar = Scrollbar.get(looksItem, {});
          const widthProduct = product.offsetWidth;
          const windowWidth = window.innerWidth;
          const offsetCenter = (windowWidth - widthProduct) / 2;
          const offsetProduct = product.getBoundingClientRect().x;
          const correctScroll = offsetProduct - offsetCenter
          scrollbar.scrollTo(scrollbar.scrollLeft + correctScroll, 0, 600, {
            callback: () => this.setState({ hasScrolledCenter: false})
          })
          // scrollbar.scrollLeft = scrollbar.scrollLeft + correctScroll
        }
        document.body.classList.add('navigator--hidden');
        if(window.dataLayer){
          window.dataLayer.push({
            event: 'view_content_hf',
            EventCategory: 'View_content_hf',
            EventAction: helperObject[sku].name,
            EventLabel:  sku
          });   
        }
        
        this.setState({ hideMessage: true});
           
      }else {
        document.body.classList.remove('navigator--hidden');
        let parentElem = e.currentTarget.closest('.j-look');
        parentElem.classList.remove('look--open');
        this.setState({ lookOpen: false});
      }
      
    };

    this.trackBuyButton = (sku) => {
      if(window.dataLayer){
        window.dataLayer.push({
          event: 'buy_item_hf',
          EventCategory: 'Buy_item_LP',
          EventAction: helperObject[sku].name,
          EventLabel: sku
        });   
      }
      
    }
    

    this.getViewport = () => {
      // return WindowHelper.window.innerWidth;
      if(typeof window !== 'undefined'){
        return window.safari ? document.body.parentNode.clientWidth : window.innerWidth;
      }
    }

    this.showMessageScroll = () => {
      if(isMobileDescktop) {
        if(document.body.classList.contains('navigator--hidden')) {
          document.body.classList.remove('navigator--hidden');   
        }
        if(this.state.hideMessage && !this.state.lookOpen) {
          this.setState({ hideMessage: false});
          this.setState({ hasClicked: true});
        }
      }
      if(this.state.lookOpen) {
        this.closeHotspot();
      }
    } 

    return (
      <>
        <div className={`hint ${this.state.hideMessage ? 'hidden' : ''} ${this.state.hasClicked ? 'hint--show' : ''}`}>
          <span className="hint__icon">
            <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.28867 0.469817L0.46981 3.28867C0.210341 3.54814 0.210341 3.96882 0.46981 4.22829C0.729278 4.48776 1.14996 4.48776 1.40943 4.22829L4.22829 1.40944C4.48776 1.14997 4.48776 0.729285 4.22829 0.469817C3.96882 0.210348 3.54814 0.210348 3.28867 0.469817Z" fill="black"/>
              <path d="M4.22827 6.10758L1.40942 3.28872C1.14995 3.02925 0.729265 3.02925 0.469796 3.28872C0.210327 3.54819 0.210327 3.96887 0.469796 4.22834L3.28865 7.0472C3.54812 7.30666 3.9688 7.30666 4.22827 7.0472C4.48774 6.78773 4.48774 6.36705 4.22827 6.10758Z" fill="black"/>
            </svg>
            <svg className="hint__iconRotate" width="5" height="8" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.28867 0.469817L0.46981 3.28867C0.210341 3.54814 0.210341 3.96882 0.46981 4.22829C0.729278 4.48776 1.14996 4.48776 1.40943 4.22829L4.22829 1.40944C4.48776 1.14997 4.48776 0.729285 4.22829 0.469817C3.96882 0.210348 3.54814 0.210348 3.28867 0.469817Z" fill="black"/>
              <path d="M4.22827 6.10758L1.40942 3.28872C1.14995 3.02925 0.729265 3.02925 0.469796 3.28872C0.210327 3.54819 0.210327 3.96887 0.469796 4.22834L3.28865 7.0472C3.54812 7.30666 3.9688 7.30666 4.22827 7.0472C4.48774 6.78773 4.48774 6.36705 4.22827 6.10758Z" fill="black"/>
            </svg>
          </span>
          <span className="hint__txt"><Trans>scroll_hint</Trans></span>
        </div>
        <div className={`looks j-looks ${this.state.openedHotspot !== null ? 'looks--index' : ''}`} ref='looksItem' onClick={() => { this.showMessageScroll()}}>
          <div className="looks__cont">
            {
              looks.map((look, index) => {
                  return(
                    <div className={`look look--${index} j-look`} key={`look-${index}`}>
                      <picture className="look__img">
                        <source media="(min-width:768px)" srcSet={look.imgDesktop}></source>
                        <source media="(min-width:270px)" srcSet={look.imgMobile}></source>
                        <img src={look.imgDesktop} alt={`look-${index}`}/>
                      </picture>
                      <ul className="look__hotspots">
                        {
                          look.hotspots && look.hotspots.map((hp, j) => {

                            return(
                              <li className={`look__hotspot j-hotSpot ${this.state.openedHotspot === index + ''+j ? 'look__hotspot--open' : ''}`} 
                                style={{top: isMobile ? hp.topMobile : hp.top, left: isMobile ? hp.leftMobile : hp.left}} 
                                key={`hotspot-${index}${j}`}>
                                <button className="hotspot__btn j-buttonHotspot" onClick={(e) => this.openHotspot(e,  index + ''+j, hp.productSku)}>
                                  <span className="hotspot__txt">open</span>
                                  <span className="hotspot__btn__outside"></span>
                                </button>
                                <div className="hotspot__product">
                                  <a href="#" className="hotspot__producClose"
                                     onClick={(e) => this.openHotspot(e, null)}
                                     aria-label="close"
                                     tabIndex={`${this.state.openedHotspot === index + ''+j  ? '0' : '-1'}`}>
                                    <span className="hotspot__producCloseIcon i-close"></span>
                                  </a>
                                  <img className="hotspot__productImg" alt={helperObject[hp.productSku].name} src={hp.productImg}/>
                                  <p className="hotspot__productName">{helperObject[hp.productSku].name}</p>
                                  <a href={helperObject[hp.productSku]['url_ecom']} 
                                     tabIndex={`${this.state.openedHotspot === index + ''+j  ? '0' : '-1'}`}
                                     onClick={()=>this.trackBuyButton(hp.productSku)}
                                     
                                     className="hotspot__productLink"><Trans>cta_buy_item</Trans></a>
                                </div>
                              </li>
                            )
                          })
                        }
                      </ul>
                    </div>
                  )
              })
            }  
          </div>
        </div>
          
        <div className="rotateDevice">
            <img className="rotateDevice__logo" src={logo} alt="Loro Piana"/>
            <img className="rotateDevice__icon" src={icon} alt="Icon rotate device"/>
        </div>
      </>
      )  
  }
  
}
export default Looks;
